import './css/app.scss'
import '../views'
import lazyLoad from './js/utils/blazy'
import './js/utils/dataLayer'
import './js/utils/windowHeightCalc'
import './js/utils/accordion'
import { initTabs } from './js/utils/tab'

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    lazyLoad()
    initTabs()
  },
  { once: true }
)
